import { baseFetch } from '../../baseFetch';
import { ExitStatusResponseSchema } from '../../schemas/ExitStatusResponseSchema';
import {
  OrderUpdate,
  UpdateOrderResponseSchema,
  UpdateShowDeltaTResponseSchema,
} from './orders.schema';

export const updateOrderShowDeltaT = (
  orderId: number,
  deltaTVisible: boolean,
) => {
  return baseFetch(
    'internal-v2',
    `/solar_orders/${orderId}/show_delta_t`,
    UpdateShowDeltaTResponseSchema.defined(),
    {
      method: 'PATCH',
      requestBody: {
        show_delta_t: deltaTVisible,
      },
    },
  );
};

export const updateOrder = (orderId: number, updates: OrderUpdate) => {
  return baseFetch(
    'internal-v2',
    `/solar_orders/${orderId}`,
    UpdateOrderResponseSchema.defined(),
    {
      method: 'PUT',
      requestBody: updates,
    },
  );
};

export const updateOrderStatus = (orderUuid: string, newStatus: number) => {
  return baseFetch(
    'internal-v2',
    `/solar_orders/${orderUuid}/status`,
    ExitStatusResponseSchema.defined(),
    {
      method: 'PUT',
      requestBody: { status: newStatus },
    },
  );
};
